import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface Options {
	enabled?: boolean;
}

export const fetchSocialProfile = async (uuid?: number) => {
	const url = uuid ? `/socialprofile/profile/${uuid}/` : "/socialprofile/profile/";

	const { data } = await cmsClient.get<UserSocialProfile>(url);

	return data;
};

const useSocialProfile = (
	uuid?: number,
	options: Options = { enabled: true }
) => {
	const query = useQuery(
		["social-profile", uuid],
		() => fetchSocialProfile(uuid),
		{
			enabled: options.enabled,
		}
	);

	return query;
};

export default useSocialProfile;
